import React from 'react';
import {
  Activity, Brain, Bug, Calendar, ChartColumn, CircleDot, CopyPlus, Dna, Droplet, Droplets, Eye, FileText, FlaskConical, FlaskRound,
  Gauge, Hash, Info, Layers, Leaf, List, ListChecks, Mountain, Package, ScanLine, Scale, Sprout, Tag, TestTube, TestTubes, Thermometer,
  ToggleLeft, Trees, Type, Wind,
} from 'lucide-react';

// Presentation only: which drawing stands for a code. Names, order and rules
// always come from the API.
function Swab() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 20 14.5 9.5" /><rect x="14" y="2.6" width="6" height="9" rx="3" transform="rotate(45 17 7.1)" />
  </svg>;
}

function StoolContainer() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 4h14v4H5z" /><path d="M6.5 8v10a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3V8" /><path d="M10 13h4M10 17h2" />
  </svg>;
}

function Tissue() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 3c3.6 0 6.8 2.3 7.8 5.6s0 7-2.6 9.2-6.9 2.9-10 1.2-5-5.2-4.2-8.8S8.4 3 12 3Z" />
    <circle cx="9.5" cy="10" r="1.2" /><circle cx="14.5" cy="13.5" r="1.2" /><circle cx="10.5" cy="15.5" r=".9" />
  </svg>;
}

const SPECIMENS = {
  whole_blood: Droplet, paxgene_blood: TestTube, dry_blood: CircleDot, cfdna: Dna, plasma: TestTubes, serum: TestTubes, csf: Brain,
  saliva: Droplets, buccal_swab: Swab, swab: Swab, vaginal_cervical_swab: Swab, stool: StoolContainer, urine: FlaskRound, tissue: Tissue,
  ffpe_tissue: Layers, cell_pellet: CircleDot, extracted_dna: Dna, extracted_rna: Dna, amplicon: CopyPlus, soil: Mountain,
  environmental: Trees, algae: Sprout, bacteriophage: Bug, sputum_bal: Wind, plant: Leaf, other: Package,
};
// An acceptance section stands for its first sample type.
const CATEGORIES = {
  blood: Droplet, saliva: Droplets, stool: StoolContainer, isolated_dna_rna: Dna, tissue: Tissue, ffpe_tissue: Layers, cell_pellet: CircleDot,
  plasma_serum_csf: TestTubes, urine: FlaskRound, cell: CircleDot, swab: Swab, soil_environmental: Mountain,
};
const STAGES = { extraction: FlaskConical, qc: Gauge, library_preparation: Layers, sequencing: ScanLine, ms_run: Activity, data_analysis: ChartColumn };
const CHECKS = { labels: Tag, container: TestTube, clarity: Eye, temperature: Thermometer, amount: Scale, information: FileText, other: Info };
const FIELDS = { option: List, options: ListChecks, number: Hash, text: Type, date: Calendar, boolean: ToggleLeft };

function glyph(map, fallback) {
  return function Glyph({ code }) {
    const Icon = Object.hasOwn(map, code) ? map[code] : fallback;
    return <Icon aria-hidden="true" />;
  };
}

export const SpecimenGlyph = glyph(SPECIMENS, Package);
export const CategoryGlyph = glyph(CATEGORIES, Package);
export const StageGlyph = glyph(STAGES, FlaskConical);
export const CheckGlyph = glyph(CHECKS, Info);
export const FieldGlyph = glyph(FIELDS, Type);
